import { service } from '../../../../helpers/http' 

export const ActionGetPlanTypes = ({ dispatch }, payload) => { 
    return service({
        module: 'planType',
        action: 'getPlanTypes',
        payload: payload
    })
}

export const ActionPostPlanTypes = ({ dispatch }, payload) => {

    return service({
        module: 'planType',
        action: 'postPlanTypes',
        payload: payload
    })
    
}

export const ActionPutPlanTypes = ({ dispatch }, payload) => {

    return service({
        module: 'planType',
        action: 'putPlanTypes',
        payload: payload
    })
    
}

export const ActionDeletePlanTypes = ({ dispatch }, payload) => {

    return service({
        module: 'planType',
        action: 'deletePlanTypes',
        payload: payload
    })
    
}
